export const HEADER_APPDOMAIN = 'X-APPDOMAINID';
export const HEADER_ZALANDO_CLIENT_ID = 'x-zalando-client-id';
export const HEADER_CLIENT_IP = 'X-Forwarded-For';
export const HEADER_CLIENT_TYPE = 'client_type';
export const HEADER_FLOW_ID = 'x-flow-id';
export const HEADER_SALES_CHANNEL = 'X-Sales-Channel';
export const HEADER_ACCEPT_LANGUAGE = 'Accept-Language';
export const HEADER_CSRF = 'x-xsrf-token';
export const HEADER_AUTHORIZATION = 'Authorization';
export const HEADER_CONTENT_TYPE = 'Content-Type';
export const CONTENT_TYPE_DEFAULT = 'application/json';
export const CONTENT_TYPE_TEXT = 'text/plain';
//# sourceMappingURL=constants.js.map